module.exports = __webpack_public_path__ + "img/retrospect-7.51382cb8.jpg";